// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"7924":"f3d523b32c56dc44de3f","8006":"d4fec2d03257e7588098","8194":"bfe96d2fc5202677f088"}[chunkId] + ".js";
};